var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "g-product-card g-product-card__hoverable g-layout__item js-gtm-impression",
      attrs: {
        "data-gtm-name": _vm.result.name,
        "data-gtm-id": _vm.result.code,
        "data-gtm-price": _vm.result.price,
      },
    },
    [
      _c(
        "a",
        {
          staticClass: "g-product-card__link",
          attrs: {
            href: _vm._f("rewriteUrl")(_vm.result.url),
            title: _vm.result.name,
          },
        },
        [
          _c("div", { staticClass: "g-product-card__image" }, [
            _vm.flag
              ? _c("span", { class: `g-product-flag g-flag-${_vm.flagType}` }, [
                  _vm._v(_vm._s(_vm.flag)),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("img", {
              directives: [
                {
                  name: "lazy",
                  rawName: "v-lazy",
                  value: {
                    src: _vm.result.thumbnailImageUrl,
                    error: _vm.errorImage,
                    loading: _vm.loadingImage,
                  },
                  expression:
                    "{ src: result.thumbnailImageUrl, error: errorImage, loading: loadingImage }",
                },
              ],
              staticClass: "g-product-card__image-source",
              attrs: { alt: "" },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "g-product-card__footer" }, [
            _vm.result.cmn_name?.length
              ? _c("span", { staticClass: "g-product-card__brand" }, [
                  _vm._v(_vm._s(_vm.result.name)),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", {
              staticClass: "g-product-card__name",
              domProps: { innerHTML: _vm._s(_vm.displayName) },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "g-product-card__information" }, [
              _vm.result.variant_price_range?.length
                ? _c("div", { staticClass: "g-product-card__pricing" }, [
                    _c("span", { staticClass: "g-product-card__price" }, [
                      _vm._v(_vm._s(_vm.result.variant_price_range)),
                    ]),
                  ])
                : _c("div", { staticClass: "g-product-card__pricing" }, [
                    _c(
                      "span",
                      {
                        class: [
                          "g-product-card__price",
                          {
                            "g-product-card__price--sale":
                              _vm.result.base_price > _vm.result.price,
                          },
                        ],
                      },
                      [_vm._v(_vm._s(_vm._f("toCurrency")(_vm.result.price)))]
                    ),
                    _vm._v(" "),
                    _vm.result.base_price > _vm.result.price
                      ? _c("s", { staticClass: "g-product-card__base-price" }, [
                          _vm._v(
                            _vm._s(_vm._f("toCurrency")(_vm.result.base_price))
                          ),
                        ])
                      : _vm._e(),
                  ]),
              _vm._v(" "),
              _vm.availabilityItems?.length
                ? _c(
                    "div",
                    { staticClass: "g-product-card__availability" },
                    _vm._l(_vm.availabilityItems, function (item) {
                      return _c(
                        "div",
                        {
                          key: item.name,
                          staticClass: "g-product-card__availability-item",
                        },
                        [
                          _c("span", {
                            class: `g-product-card__availability-item-icon ${item.icon}`,
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(" "),
                          item.name
                            ? _c("span", { staticClass: "u-hide-visually" }, [
                                _vm._v(_vm._s(item.name)),
                              ])
                            : _vm._e(),
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }